import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";

import LoginForm from "./login-form/login-form.jsx";

import commonStyles from "../../../../Styles/site.css";

class IndexContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <BrowserRouter>
                <Route path="/account/login" exact component={LoginForm} />
            </BrowserRouter>
        );
    }
}

ReactDOM.render(
    <IndexContainer />,
    document.getElementById("login-root")
);